import { render, staticRenderFns } from "./CreateAutoRent2.vue?vue&type=template&id=bc3db4f0&"
import script from "./CreateAutoRent2.vue?vue&type=script&lang=js&"
export * from "./CreateAutoRent2.vue?vue&type=script&lang=js&"
import style0 from "./CreateAutoRent2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDatePicker,VFlex,VLayout})
